exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".online-training p.title{color:#bcbcbc;font-size:16px;margin-bottom:4px;font-weight:500}.online-training h1{margin:0 0 20px 0;color:#1a1a1a}.online-training .take-note{max-width:500px}.online-training .take-note h3{color:#ff8200;font-size:20px;margin-bottom:4px}.online-training .take-note span{margin-top:15px;color:#7a8189;font-size:14px}.online-training p.note-to-pass{margin-top:10px;font-size:14px;color:#7a8189}.online-training a.go-on,.online-training button.go-on{width:120px;height:46px;background:#ff8200;color:#fff;border-radius:2px;margin-top:25px}", ""]);

// exports
